import Extension from "@packages/sections/extension";

const selectors = {
    tooltip: '[data-tooltip]'
};

const classes = {
    tooltipped: 'tooltipped'
};

class TooltipExtension extends Extension {
    async onLoad() {
        await super.onLoad();

        await this.initTooltips();
    }

    async initTooltips() {
        const container = this.container;
        if (!container) {
            return;
        }

        const tooltips = container?.querySelectorAll(selectors?.tooltip);
        if (!tooltips) {
            return;
        }

        if (!tooltips?.length) {
            return;
        }

        const { default: hoverintent } = await import('hoverintent');
        if (!hoverintent) {
            return;
        }

        tooltips?.forEach((tooltip) => {
            const content = tooltip?.dataset?.tooltip;
            if (!content) {
                return;
            }

            hoverintent(tooltip,  ()=> {
                tooltip?.classList?.add(classes?.tooltipped);
            },  () => {
                tooltip?.classList?.remove(classes?.tooltipped);
            })?.options({
                timeout: 500,
                handleFocus: true
            });
        });
    }
}

export default TooltipExtension;
